// @flow

// Name
export const MODEL = 'Layers'
// Api End Point
export const URL = 'layer/'

// Model Properties
export const PROP_ID = 'id'
export const PROP_LAYER_ID = PROP_ID
export const PROP_ASSET = 'asset'
export const PROP_LABEL = 'label'
export const PROP_NAME = 'name'
export const PROP_URL = 'url'
export const PROP_SRCTYPE = 'srcType'
export const PROP_CATEGORY = 'category'
export const PROP_YIELD_DEFAULT = 'yield_default'
export const PROP_LAYERTYPE = 'layerType'
export const PROP_SHAPEFILE_NAME = 'shapefileName'
export const PROP_SEASON = 'season'
export const PROP_BOUNDS = 'bounds'
export const PROP_IMAGERY_DATE = 'imagery_date'
export const PROP_DATE_CREATED = 'date_created'
export const PROP_IMAGERY_END_DATE = 'imagery_end_date'

// Layer Type Options
export const LAYER_TYPE_PATRICIA = 'Patricia'
export const LAYER_TYPE_ELVYRA = 'Elvyra'
export const LAYER_TYPES = [LAYER_TYPE_ELVYRA, LAYER_TYPE_PATRICIA]

export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss' // 2017-08-02T00:00:00
